var config = {
    maxUnreadsCount: 50,
    maxTrackableUnreads: 60,
};
export default config;
